export function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function isToday(iso) {
  if (!iso) return false;
  // Compare in Asia/Kolkata so the "New today" badge matches the backend's IST day boundary
  const opts = { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' };
  const d = new Intl.DateTimeFormat('en-CA', opts).format(new Date(iso));
  const today = new Intl.DateTimeFormat('en-CA', opts).format(new Date());
  return d === today;
}

export function locationLabel(row) {
  return [row.city, row.state].filter(Boolean).join(', ');
}
